import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocalizedPath } from '../utils/i18n-routes';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
  children: React.ReactNode;
}

/**
 * Link component that automatically adds language prefix for SEO
 */
const LocalizedLink: React.FC<LocalizedLinkProps> = ({ to, children, ...props }) => {
  const { i18n } = useTranslation();
  const localizedTo = getLocalizedPath(to, i18n.language);

  return (
    <Link to={localizedTo} {...props}>
      {children}
    </Link>
  );
};

export default LocalizedLink;

